import * as React from 'react';
import './checkCard.css';

interface ICheckCardProps {
    id?: string;
    value?: string[];
    label: string;
    array: Map<string, string>;
    width?: string;
    height?: string;
    OnChage?: (array: string[]) => void;
}

class CheckCard extends React.Component<ICheckCardProps> {
    constructor(props: ICheckCardProps) {
        super(props);
    }

    OnClickChecked = (event: React.MouseEvent<HTMLDivElement>) => {
        let KeyItem: string | null = event.currentTarget.getAttribute('itemID');
        if (this.props.OnChage !== undefined && KeyItem != null && this.props.value !== undefined) {
            let TempArrayValue = [...this.props.value];
            TempArrayValue.push(KeyItem);
            this.props.OnChage(TempArrayValue);
        }
    };

    OnClickNotChecked = (event: React.MouseEvent<HTMLDivElement>) => {
        let KeyItem: string | null = event.currentTarget.getAttribute('itemID');
        if (this.props.OnChage !== undefined && KeyItem != null && this.props.value !== undefined) {
            let IndItem: number = Number(KeyItem);
            let TempArrayValue = [...this.props.value];
            TempArrayValue.splice(IndItem, 1);
            this.props.OnChage(TempArrayValue);
        }
    };

    render() {
        let width: string = this.props.width !== undefined ? this.props.width : '136px';
        let height: string = this.props.height !== undefined ? this.props.height : '136px';
        let id: string = this.props.id !== undefined ? this.props.id : '';
        let value: string[] = this.props.value !== undefined ? this.props.value : [];
        let values: string[] = Array.from(this.props.array.values());
        let keys: string[] = Array.from(this.props.array.keys());

        if (this.props.value !== undefined) value = this.props.value;

        let sty = {
            width: width,
            height: height
        };

        let CheckBoxView = keys.map((keyItem: string, ind: number) => {
            let valueItem: string = values[ind];
            let indexValue = value.indexOf(keyItem);
            if (indexValue != -1) {
                return (
                    <div className="checkCard_def_checkbox">
                        <div onClick={this.OnClickNotChecked} itemID={indexValue.toString()}>
                            <svg
                                className="checkCard_def_input"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect
                                    x="0.1"
                                    y="0.1"
                                    width="11.8"
                                    height="11.8"
                                    fill="#E4F4F7"
                                    stroke="#66C3D0"
                                    stroke-width="0.2"
                                />
                                <path
                                    d="M8.39959 0.429971C6.89263 2.89964 5.31526 5.32212 3.68155 7.69741C2.9492 6.98954 2.20276 6.28167 1.47041 5.57381C0.653553 4.78729 -0.543561 6.10864 0.273293 6.91089C1.24507 7.85471 2.21684 8.78281 3.2027 9.72663C3.51254 10.0255 4.10406 10.1514 4.39982 9.72663C6.30112 7.021 8.132 4.23672 9.85021 1.38952C10.4699 0.36705 9.00519 -0.576773 8.39959 0.429971Z"
                                    fill="#66C3D0"
                                />
                            </svg>
                        </div>
                        <div className="checkCard_def_input_label">{valueItem}</div>
                    </div>
                );
            } else {
                return (
                    <div className="checkCard_def_checkbox">
                        <div onClick={this.OnClickChecked} itemID={keyItem}>
                            <svg
                                className="checkCard_def_input"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect
                                    x="0.1"
                                    y="0.1"
                                    width="11.8"
                                    height="11.8"
                                    fill="white"
                                    stroke="#8B8B8B"
                                    stroke-width="0.2"
                                />
                            </svg>
                        </div>
                        <div className="checkCard_def_input_label">{valueItem}</div>
                    </div>
                );
            }
        });

        return (
            <div className="checkCard_def_main" style={sty}>
                <div className="checkCard_def_label">{this.props.label}</div>
                {CheckBoxView}
            </div>
        );
    }
}

export default CheckCard;
